import type { IconSvgObject } from './types';

const CircleArrowUpDownIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.3 8.5V15.5M9.3 8.5C8.58465 8.5 7.5 10.25 7.5 10.25M9.3 8.5C10.004 8.5 11.1 10.25 11.1 10.25M14.7 15.5V8.5M14.7 15.5C13.996 15.5 12.9 13.75 12.9 13.75M14.7 15.5C15.404 15.5 16.5 13.75 16.5 13.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.55", key: "1" }]
];

export default CircleArrowUpDownIcon;
